module.exports = __webpack_public_path__ + "files/8ed8ec304f2cfd33af4e89a64fe7488d.png";